var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
const DEFAULT_LIMIT = 25;
let DashboardMaterialsController = (_class = class DashboardMaterialsController extends Controller {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "queryParams", [{
      courseParam: 'course'
    }, {
      filterParam: 'filter'
    }, {
      sortByParam: 'sortBy'
    }, {
      showAllMaterialsParam: 'showAll'
    }, {
      limitParam: 'limit'
    }, {
      offsetParam: 'offset'
    }]);
    _initializerDefineProperty(this, "courseParam", _descriptor, this);
    _initializerDefineProperty(this, "filterParam", _descriptor2, this);
    _initializerDefineProperty(this, "sortByParam", _descriptor3, this);
    _initializerDefineProperty(this, "limitParam", _descriptor4, this);
    _initializerDefineProperty(this, "offsetParam", _descriptor5, this);
    _initializerDefineProperty(this, "showAllMaterialsParam", _descriptor6, this);
  }
  get offset() {
    if (!this.offsetParam) {
      return 0;
    }
    const offset = parseInt(this.offsetParam, 10);
    return offset.isNaN ? 0 : offset;
  }
  get limit() {
    if (!this.limitParam) {
      return DEFAULT_LIMIT;
    }
    const limit = parseInt(this.limitParam, 10);
    return limit.isNaN ? DEFAULT_LIMIT : limit;
  }
  get course() {
    return this.courseParam ?? '';
  }
  get filter() {
    return this.filterParam ?? '';
  }
  get sortBy() {
    return this.sortByParam ?? 'firstOfferingDate:desc';
  }
  get showAllMaterials() {
    return this.showAllMaterialsParam ?? false;
  }
  setCourse(value) {
    this.courseParam = value === '' ? null : value;
  }
  setFilter(value) {
    this.filterParam = value === '' ? null : value;
  }
  setOffset(value) {
    this.offsetParam = value ?? null;
  }
  setLimit(value) {
    this.limitParam = value ?? null;
  }
  setSortBy(value) {
    this.sortByParam = value === 'firstOfferingDate:desc' ? null : value;
  }
  toggleMaterialsMode() {
    this.setLimit(null);
    this.setOffset(null);
    this.showAllMaterialsParam = this.showAllMaterialsParam ? null : true;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "courseParam", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "filterParam", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sortByParam", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "limitParam", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "offsetParam", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showAllMaterialsParam", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setCourse", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCourse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOffset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOffset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLimit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSortBy", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSortBy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMaterialsMode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMaterialsMode"), _class.prototype), _class);
export { DashboardMaterialsController as default };